import { render, staticRenderFns } from "./DigitalPresence.vue?vue&type=template&id=4b156c93&scoped=true&"
import script from "./DigitalPresence.vue?vue&type=script&lang=js&"
export * from "./DigitalPresence.vue?vue&type=script&lang=js&"
import style0 from "./DigitalPresence.vue?vue&type=style&index=0&id=4b156c93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b156c93",
  null
  
)

export default component.exports